import * as m from 'mithril';
import CustomSvgIcon, { CustomSvgIconType } from '../../../components/CustomSvgIcon';
import { getIntlStringValue } from '../../../helpers/StringHelpers';
import { TripResultDTO } from '../../../apiclient/ApiDtos';
import { MessageProvider } from '../../../context/AppMessages';
import dayjs = require('dayjs');
import { getDayRangeLabel } from '../../../components/TripSearchResultSummaryView';
import MiniTripItineraryView from '../../../components/MiniTripItineraryView';

interface TripSummaryComponentAttrs {
    isAutoExpanding?: boolean,
    numberOfSeats: number,
    messageProvider: MessageProvider,
    trip: TripResultDTO,
    showAsMultipleSeatPrice?: boolean,
    onViewSeatButtonClick: (tripResult: TripResultDTO) => void,
    onViewOperatorPhotosButtonClick: (tripResult: any) => void
}
export function ExpandableTripSummaryComponent(): m.Component<TripSummaryComponentAttrs> {
    let isExpandingView = false;
    return {
        view(vnode) {
            let { trip, messageProvider } = vnode.attrs;
            let currLang = vnode.attrs.messageProvider.getCurrentLang();
            let scheduledAt = trip.departure.scheduledAt;
            let hour24 = dayjs(trip.departure.scheduledAt).hour();
            let dayNightIconClass: CustomSvgIconType = (hour24 < 16) ? 'sun' : 'moon';
            /* if (vnode.attrs.isAutoExpanding == true) {
                isExpandingView = vnode.attrs.isAutoExpanding && !wantToCollapse;
            } */
            return m("div.p-3", {
                style: isExpandingView ? "background-color: #fbfbfb !important;" : "",
                onclick: !isExpandingView
                    ? () => {
                        isExpandingView = true;
                    }
                    : undefined
            },
                m("div.d-flex justify-content-between align-items-center",

                    m("div.d-flex align-items-center",
                        /* isExpandingView ? null
                            : */
                        m("span.text-muted small mr-1",
                            messageProvider.get("trip_group.departs"),
                            " ▹ "
                        ),
                        m("span.font-weight-bold text-primary-variant",
                            dayjs(scheduledAt).format("hh:mm A")
                        ),
                        m("span", [
                            m("span", { class: "ml-1 mr-1 " },
                                m(CustomSvgIcon, {
                                    iconType: dayNightIconClass,
                                    themeCssClass: "svg-info svg-small"
                                })
                            ),
                            m("span.text-body-sm", getDayRangeLabel(dayjs(scheduledAt).hour(), vnode.attrs.messageProvider))
                        ]),

                        /* (trip.highlights && trip.highlights.length > 0) &&
                                m("div.mt-2", [
                                    trip.highlights.map(hl => {
                                        return m("span.operator-hightlight-tag-service mr-1  mb-1 font-weight-bold text-primary",
                                            getIntlStringValue(hl, vnode.attrs.messageProvider.getCurrentLang())
                                        )
                                    })
                                ]
                                ), */
                    ),

                    m("div",
                        isExpandingView ?
                            m("div", {
                                onclick: isExpandingView
                                    ? () => {
                                        isExpandingView = false;
                                    }
                                    : undefined,
                            },
                                m("button.btn btn-outline-light btn-sm px-2 py-1 shadow-sm_ bg-white", {
                                    style: "border-radius: 0.5rem !important;"
                                }, m(CustomSvgIcon, {
                                    iconType: 'keyboard_arrow_up',
                                    themeCssClass: "svg-medium svg-info"
                                })
                                )
                            )
                            :
                            m("button.btn btn-outline-info btn-small px-2 py-1 shadow-sm bg-white", {
                                style: "border-radius: 0.5rem !important;"
                            },
                                m(CustomSvgIcon, {
                                    iconType: isExpandingView ? 'keyboard_arrow_up' : 'keyboard_arrow_down',
                                    themeCssClass: "svg-medium svg-info"
                                })
                            )

                    )
                ),
                isExpandingView &&
                m("div",
                    m("div.mt-1",
                        m("span.text-body-sm", { class: "text-muted" }, getIntlStringValue(trip.fullRouteName, currLang)),
                    ),

                    m("div.mt-1", [
                        m(MiniTripItineraryView, {
                            messageProvider: vnode.attrs.messageProvider,
                            trip: trip,
                            size: 'small',
                            fill: false
                        }),




                        (trip.highlights && trip.highlights.length > 0) &&
                        m("div.mt-2", [
                            trip.highlights.map(hl => {
                                return m("span.operator-hightlight-tag-service mr-1  mb-1 font-weight-bold text-primary",
                                    getIntlStringValue(hl, vnode.attrs.messageProvider.getCurrentLang())
                                )
                            })
                        ]
                        ),

                        m("div.d-flex justify-content-between align-items-end mt-3 ",
                            m("div", [
                                (vnode.attrs.showAsMultipleSeatPrice == true && trip.priceRange.max.amount > trip.priceRange.min.amount) ?
                                    m("div.mb-2",
                                        m("small.text-muted",
                                            "(",
                                            vnode.attrs.messageProvider.get("trip.multiple_price"),
                                            ")")
                                    )
                                    : "",
                                m("div.text-right_ mr-5_", [
                                    m("div",
                                        m("span", vnode.attrs.numberOfSeats),
                                        m("span.ml-1",
                                            vnode.attrs.numberOfSeats > 1 ? vnode.attrs.messageProvider.get("seats") : vnode.attrs.messageProvider.get("seat")
                                        )
                                        ,
                                        " ▹ ",
                                        m("span.text-success font-weight-bold", { class: "" }, "MMK "),
                                        m("span.text-success font-weight-bold",
                                            (trip.priceRange.min.amount * vnode.attrs.numberOfSeats).toLocaleString("en-US"),
                                            (trip.priceRange.max.amount > trip.priceRange.min.amount) ? " +" : ""
                                        )
                                    )
                                ]),



                            ]),
                            m("div",
                                m("a._ml-5", {
                                    role: "button",
                                    class: "btn btn-primary text-white px-4",
                                    style: "",
                                    href: "#",
                                    onclick: function (event) {
                                        event.preventDefault();
                                        vnode.attrs.onViewSeatButtonClick(trip);
                                    }

                                }, [
                                    m("span", { class: "" }, vnode.attrs.messageProvider.get("select")),
                                    // hidden on xs devices
                                    m("span", { class: "ms-1 ml-1 d-none d-sm-inline" },
                                        m(CustomSvgIcon, {
                                            iconType: 'double_chevron_right',
                                            themeCssClass: "svg-x-small svg-white"
                                        })
                                    )
                                ])
                            )
                        )
                    ])
                )
            )
        }
    }
}